<template>
  <div>
    <div >
      <!-- <h1>{{$t('userInfo.name')}}</h1> -->
      <!--顶部导航-->
      <navgate ></navgate>
      <!--内容区域-->
      <div class="web_box">
        <!--banner-->
        
        <div class="banner_box">
          <template v-if="newsList && newsList.banners">
            <swiper
              :options="swiperOption"
            >
                <swiper-slide v-for="(item,index) in newsList.banners" :key="index"><img :src="item.bannerUrl" @click="toDetailPage(item)"></swiper-slide>
                <div class="swiper-pagination" slot="pagination"> </div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            
            </swiper>
          </template>
        </div>
        <div class="web_content">
          <!--新闻动态-->
          <ImageTitleListView titleName="公益项目" :messageList="newsList.list" :perPage="perPage" detailRouter="fundDetail"></ImageTitleListView>
        </div>
        <!--联系我们-->
        <footer-build></footer-build>
      </div>
      <!--回到顶部-->
      <!-- <div class="top_box">
        <div><i class="iconfont icon-web-top"></i></div>
      </div> -->
      
    </div>
    <router-view/>
  </div>
  
</template>

<script>
import store from '../../store' 

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import HttpUtils from "../../util/HttpUtils";
import ImageTitleListView from './container/ImageTitleListView'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'fundProject',
  components:{ImageTitleListView,swiper, swiperSlide},
  props: {
    
  },
  created(){
  },
  data () {
    return {
      newsList:{total:0,perPage:1,list:[]},
      perPage:1,
      swiperOption: {
          spaceBetween: 30,
          effect: 'fade',
          loop:true,
          autoplay:{
            delay:3000,
            disableOnInteraction:false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
    }
  },
  
  methods:{
    toDetailPage(item){
      
      let url = this.$router.resolve({
         name: 'fundDetail',
         query: {detailId:item.messageId}
       });
       this.$PageUtil.openNewPage(this,url.href)
       
    },
    loadNewsData(){
      // this.newsList = require('../../store/json/fundProjects.json')
      let that = this;
      new HttpUtils().sendGet(that, '/foundation_api/fundProjects.json',  { }, function (sucess, res) {
        that.newsList = res
        that.perPage = that.newsList.perPage;
      });
      
    },
    secondItemClick(pageName){
      this.$router.push(pageName)
    },
    
  },
  mounted(){
    this.loadNewsData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_foundation.less';
    @import '../../assets/css/ks_media.less';
    @import '../../assets/fonts/iconfont.css';
</style>
